<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/privacy-policy">Privacy Policy</router-link>
        <span class="separator">|</span>
        <router-link to="/terms-of-service">Terms of Service</router-link>
        <span class="separator">|</span>
        <router-link to="/about-us">About Us</router-link>
        <span class="separator">|</span>
        <router-link to="/contact-us">Contact Us</router-link>
      </div>
      <div class="copyright">
        &copy; {{ new Date().getFullYear() }} L2L.fun. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 20px 0;
  margin-top: 40px;
  width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
}

.footer-links {
  margin-bottom: 10px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #fff;
  text-decoration: underline;
}

.separator {
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.4);
}

.copyright {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
}
</style>
